var demographicSurveyResult = {
  question_1: "",
  answer_1: "",
  question_2: "",
  answer_2: "",
  question_3: "",
  answer_3: "",
  question_4: "",
  answer_4: "",
  question_5: "",
  answer_5: "",
  question_6: "",
  answer_6: "",
};

const q5_other_answers = createTagInput('referral_cb12', 'answer_q5');
function initForm() {
  document
    .querySelectorAll(".demographic_question")
    .forEach(function (question, index) {
      const questionKey = `question_${index + 1}`;
      demographicSurveyResult[questionKey] = question.textContent.trim();
    });
}

// grab the new “Other” checkbox and the wrapper div
const otherCheckbox   = document.querySelector('#referral_cb_other');
const otherWrapper    = document.querySelector('#referral_other_wrapper');

// when they check “Other”, show the text‐input; when they uncheck, hide & clear it
otherCheckbox.addEventListener('change', function(e) {
  otherWrapper.hidden = !e.target.checked;
  if (!e.target.checked) {
    // clear any tags the user typed
    q5_other_answers.clear();
    document.querySelector('#referral_cb12').value = '';
    updateResult({ target: otherCheckbox });
  }
});

function updateResult(event) {
  const question_response = event.target;
  let answer_input = "";
  //new
  if (question_response.classList.contains("answer_q1")) {
    answer_input =
        question_response.options[question_response.selectedIndex].value;

    demographicSurveyResult["answer_1"] = answer_input;
  }
  if (question_response.classList.contains("answer_q2")) {
    answer_input =
        question_response.options[question_response.selectedIndex].value;

    demographicSurveyResult["answer_2"] = answer_input;
  }

  if (question_response.classList.contains("answer_q3")) {
    const selected = document.querySelector(".ethnicity_option:checked");
    demographicSurveyResult["answer_3"] = selected ? selected.value : "";
  }

  if (question_response.classList.contains("answer_q4")) {
    answer_input =
        question_response.options[question_response.selectedIndex].value;

    demographicSurveyResult["answer_4"] = answer_input;
  }

  if (question_response.classList.contains("answer_q5")) {
    const allChecked = document.querySelectorAll(".referral_option:checked");
    answer_input = Array.from(allChecked).map((checkbox) => checkbox.value);
    answer_input = answer_input.join(";");
    const other_answers = q5_other_answers.getInputString();

    if (other_answers.length > 0) {
      answer_input=answer_input.length > 0 ? answer_input+';'+other_answers : other_answers;
    }
    demographicSurveyResult["answer_5"] = answer_input;
  }

  if (question_response.classList.contains("answer_q6")) {
    answer_input =
        question_response.options[question_response.selectedIndex].value;

    demographicSurveyResult["answer_6"] = answer_input;
  }

  addressInfo.demographicSurveyResult = demographicSurveyResult;
  console.log(demographicSurveyResult);
  document.querySelector("#validate_registration").value = JSON.stringify({
    addressInfo,
  });
}


const demographic_answers = document.querySelectorAll(
  ".demographic_survey_answer"
);

demographic_answers.forEach(function (answers) {
  answers.addEventListener("change", updateResult);
  answers.addEventListener("blur", updateResult);
});

const MAX = 3;
const referralCheckboxes = document.querySelectorAll('input[type="checkbox"][name="referral"]');
const limitError = document.getElementById('referral_limit_error');

referralCheckboxes.forEach(cb =>
    cb.addEventListener('change', e => {
      const checkedCount = document.querySelectorAll('input[type="checkbox"][name="referral"]:checked').length;

      if (e.target.checked && checkedCount > MAX) {
        e.target.checked = false;
        limitError.hidden = false;

        if (e.target.id === 'referral_cb_other') {
          otherWrapper.hidden = true;
          q5_other_answers.clear();
        }

        updateResult(e);
      } else {
        // any valid change hides the error
        limitError.hidden = true;
        updateResult(e);
      }
    })
);


function createTagInput(inputTagId, inputTagClass) {
  return new TagsInput({
    selector: inputTagId,
    inputClass: inputTagClass,
    duplicate : false,
    max : 3,
    groupingClass: 'demographic_survey_answer',
  });
}

initForm();
